import { CardContentProps as MuiCardContentProps } from '@mui/material/CardContent'

export type CardContentProps = MuiCardContentProps
